import io from "socket.io-client";
import { setRoomId, setParticipants, setSocketId } from "../store/actions";
import store from "../store/store";
import * as webRTCHandler from "./webRTCHandler";
import { appendNewMessageToChatHistory } from "./directMessages";

// const SERVER = "http://localhost:5002";
// const SERVER = "https://imed.serveis.in/";
const SERVER = process.env.NODE_ENV === 'production' ? "https://imedapi.serveis.in/" : "http://localhost:5002/";

let socket = null;

export const connectWithSocketIOServer = () => {
  // console.log("Connecting to Socket.IO server at:", SERVER);
  socket = io(SERVER);

  socket.on("connect", () => {
    // console.log("Connected to Socket.IO server. Socket ID:", socket.id);
    store.dispatch(setSocketId(socket.id));
  });

  socket.on("room-id", (data) => {
    const { roomId } = data;
    // console.log("Received room ID from server:", roomId);
    store.dispatch(setRoomId(roomId));
  });

  socket.on("room-update", (data) => {
    // console.log("Received room update:", data);
    if (data?.connectedUsers?.length > 0) {
      // console.log("Connected users:", data.connectedUsers);
      store.dispatch(setParticipants(data.connectedUsers));
    } else {
      console.error("Invalid or empty room-update data:", data);
    }
  });

  socket.on("conn-prepare", (data) => {
    // console.log("Preparing for new connection. Data received:", data);
    const { connUserSocketId } = data;

    webRTCHandler.prepareNewPeerConnection(connUserSocketId, false);

    // Inform the user who just joined that we have prepared for the connection
    // console.log("Emitting conn-init to:", connUserSocketId);
    socket.emit("conn-init", { connUserSocketId });
  });

  socket.on("conn-signal", (data) => {
    // console.log("Received signaling data:", data);
    webRTCHandler.handleSignalingData(data);
  });

  socket.on("conn-init", (data) => {
    // console.log("Initializing connection with existing user. Data received:", data);
    const { connUserSocketId } = data;
    webRTCHandler.prepareNewPeerConnection(connUserSocketId, true);
  });

  socket.on("user-disconnected", (data) => {
    console.log("User disconnected. Data received:", data);
    webRTCHandler.removePeerConnection(data);
  });

  socket.on("direct-message", (data) => {
    // console.log("Received direct message:", data);
    appendNewMessageToChatHistory(data);
  });
};

export const leaveRoom = () => {
  webRTCHandler.cleanupAllConnections();
  socket.emit("leave-room");
};

export const createNewRoom = (identity, onlyAudio, roomId, callback) => {
  // console.log("Creating a new room. Identity:", identity, "Only audio:", onlyAudio);
  const data = { identity, onlyAudio, roomId };

  socket.emit("create-new-room", data, (roomId) => {
    console.log("Room created with ID:", roomId);
    if (callback) {
      callback(roomId);
    }
  });
};

export const joinRoom = (identity, roomId, onlyAudio) => {
  // console.log("Joining room. Identity:", identity, "Room ID:", roomId, "Only audio:", onlyAudio);
  const data = { roomId, identity, onlyAudio };

  socket.emit("join-room", data);
};

export const signalPeerData = (data) => {
  // console.log("Sending peer signaling data:", data);
  socket.emit("conn-signal", data);
};

export const sendDirectMessage = (data) => {
  // console.log("Sending direct message:", data);
  socket.emit("direct-message", data);
};
